module.exports = __webpack_public_path__ + "img/CHARTS.3d9cd3f9.svg";